/**
 * プランナー一覧の表示分岐。
 *
 * 画面側の JSX に条件式を散らすと「0件のときに見出しだけ残る」「失敗してもローディングのまま」といった
 * 抜けが起きやすいため、取り得る表示状態を純関数として一箇所に固定する。
 *
 * 優先順は loading > error > empty > list。
 * 取得中は前回の結果や直前のエラーが残っていても必ず loading を返し、
 * 失敗時は件数に関わらず error を返して無限ローディングにならないようにする。
 */
export type AgentListViewState = "loading" | "error" | "empty" | "list";

export const resolveAgentListViewState = (params: {
  isLoading: boolean;
  error: boolean;
  agentCount: number;
}): AgentListViewState => {
  if (params.isLoading) return "loading";
  if (params.error) return "error";
  if (params.agentCount === 0) return "empty";
  return "list";
};
